/* global femcare */

femcare.newsletter.subscription = {
    $subscriptions: $('.newsletter-subscription'),
    init: function () {

        if (this.$subscriptions.length) {
            this.$subscriptions.each(function (index, element) {
                var $subscription = $(element);
                var $form = $subscription.find('form');

                $form.on('submit',
                    $.proxy(function (e) {
                        e.preventDefault();

                        if ($form.validateForm()) {
                            femcare.tracking.gaTracking.formSubmit($form);

                            $.ajax({
                                type: $form.attr('method'),
                                url: $form.attr('action'),
                                data: $form.serialize(),

                                success: $.proxy(function (response) {
                                    if (response.success === true) {
                                        this.showResponseMessage(true, $subscription);
                                    } else {
                                        this.showResponseMessage(false, $subscription);
                                    }
                                    $form.hide();
                                }, this),

                                error: $.proxy(function () {
                                    $form.hide();
                                    this.showResponseMessage(false, $subscription);
                                }, this)
                            });
                        }
                    }, this));
            }.bind(this));
        }
    },

    showResponseMessage: function (success, $subscription) {
        var title = $subscription.attr(
            success ? 'data-response-success-title' : 'data-response-fail-title'
        );
        var message = $subscription.attr(
            success ? 'data-response-success-message' : 'data-response-fail-message'
        );

        var response = '<div class="newsletter-subscription__response-title">' + title + '</div>';
        response += '<div class="newsletter-subscription__response-description">' + message + '</div>';
        $subscription.find('form')
            .parent()
            .empty()
            .html(response);
    }
};